export enum RouteGuard {
  RedirectHomeOrLogin = "REDIRECT_HOME_OR_LOGIN",
  RedirectHomeOrShowLogin = "REDIRECT_HOME_OR_SHOW_LOGIN",
  ShowPageNotFound = "SHOW_PAGE_NOT_FOUND",
}
